var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.selectRandom(["To increase participant enrolment we"]))+" "+_vm._s(_vm.joinArrayWithAnd(_vm.formatSelectMulti(_vm.data.recruitment)))+". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }